import React, { Suspense, lazy } from 'react';
import { useTranslation } from "react-i18next";
import { Container, Loading } from "@nextui-org/react";
import { AppState, useNavigation } from '../context/NavigationContext';

const HomePage = lazy(() => import('../pages/Home'));
const ScreenPage = lazy(() => import('../pages/Screen'));
const VideoStepPage = lazy(() => import('../pages/VideoStepPage').then(module => ({ default: module.VideoStepPage })));
const TrainingPage = lazy(() => import('../pages/Training').then(module => ({ default: module.TrainingPage })));
const SlideConfirmation = lazy(() => import('../pages/SlideConfirmation').then(module => ({ default: module.SlideConfirmation })));
const EvaluationPage1 = lazy(() => import('../pages/Evaluation1'));
const SettingsPage = lazy(() => import('../pages/Settings'));
const ThankYouPage = lazy(() => import('../pages/ThankYou').then(module => ({ default: module.ThankYouPage })));
const WaitingFormationPage = lazy(() => import('../pages/WaitingFormation').then(module => ({ default: module.WaitingFormationPage })));
const VideoConferencePage = lazy(() => import('../pages/VideoConferenceDummy'));
const SelectGroupPage = lazy(() => import('../pages/SelectGroup'));
const SurveyPage = lazy(() => import('../pages/Survey'));

export const MainController: React.FC = () => {
  const { currentStep, stepData } = useNavigation();
  const { t } = useTranslation();

  const renderContent = () => {
    if (stepData?.stateType === 'survey') {
      return <SurveyPage />;
    }

    if (stepData?.stateType === 'video') {
      return (
        <VideoStepPage
          title={stepData.title}
          titleKey={stepData.titleKey}
          nextRoutePath={currentStep}
          nextLabelKey={stepData.nextLabelKey}
          videoId={stepData.videoId}
        />
      );
    }

    switch (currentStep) {
      case AppState.HOME:
        return <HomePage />;
      case AppState.SCREEN:
        return <ScreenPage />;
      case AppState.SELECT_GROUP:
        return <SelectGroupPage />;
      case AppState.WAITING_FORMATION:
        return <WaitingFormationPage />;
      case AppState.TRAINING:
        return <TrainingPage />;
      case AppState.SLIDE_CONFIRMATION:
        return <SlideConfirmation />;
      case AppState.DESIGN:
        return <VideoConferencePage currentAppState={AppState.DESIGN} />;
      case AppState.PITCH:
        return <VideoConferencePage currentAppState={AppState.PITCH} />;
      case AppState.THANK_YOU:
        return <ThankYouPage />;
      case AppState.SETTINGS:
        return <SettingsPage />;
      case AppState.EVALUATION1:
      case AppState.TOOLS:
      case AppState.CLOSING_REMARKS:
        return <EvaluationPage1 />;
      default:
        return <div>{t("components.main_controller.unknown_step")}</div>;
    }
  };

  return (
    <Suspense fallback={<Container css={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}><Loading /></Container>}>
      {renderContent()}
    </Suspense>
  );
};
